import { render, staticRenderFns } from "./agronomic-import.vue?vue&type=template&id=139b90c6&scoped=true&"
import script from "./agronomic-import.vue?vue&type=script&lang=js&"
export * from "./agronomic-import.vue?vue&type=script&lang=js&"
import style0 from "./agronomic-import.vue?vue&type=style&index=0&id=139b90c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b90c6",
  null
  
)

export default component.exports